module.exports = __webpack_public_path__ + "img/double-image-hero-hyundai.fc49f3e9.png";